import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root:{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '6px 8px',
    marginTop: '100px',
    width: '100%'
  },
  title: {
    fontSize: '18px',
    fontWeight: '600',
    color: theme.palette.grey.grey700,
    lineHeight: '130%',
    letterSpacing: '-0.18px',
    marginTop: '22px',
    textAlign: 'center',
    marginBottom: '10px',
  },
  content: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > :first-of-type': {
      marginRight: '30px'
    },
    marginTop: '30px'
  },
  contextReference: {
    fontSize: '18px',
    color: theme.palette.grey.grey700,
    lineHeight: '140%',
    padding: '13px 68px',
    background: theme.palette.grey.grey100,
    marginTop: '8px',
    width: '371px',
    textAlign: 'center',
    borderRadius: '4px'
  }
}));

export default useStyles;
